import { render, staticRenderFns } from "./MedBatch.vue?vue&type=template&id=53bc6b06&scoped=true"
import script from "./MedBatch.vue?vue&type=script&lang=js"
export * from "./MedBatch.vue?vue&type=script&lang=js"
import style0 from "./MedBatch.vue?vue&type=style&index=0&id=53bc6b06&lang=scss&scoped=true"
import style1 from "./MedBatch.vue?vue&type=style&index=1&id=53bc6b06&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc6b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53bc6b06')) {
      api.createRecord('53bc6b06', component.options)
    } else {
      api.reload('53bc6b06', component.options)
    }
    module.hot.accept("./MedBatch.vue?vue&type=template&id=53bc6b06&scoped=true", function () {
      api.rerender('53bc6b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/health/MedBatch.vue"
export default component.exports